module.exports = __webpack_public_path__ + "img/bx_ms2.28dad157.png";